module.exports = __webpack_public_path__ + "static/5-30fb7e4b46f0d4162ab56e38e4a69a30.jpg";